module.exports = __webpack_public_path__ + "assets/img/upload.2f3f7b62.svg";